import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    dealerId: null,
    log: null,
    error: false,
};

const route = "dealers/views/.components/resendDealerAlertLog/redux/slice";

export const resendDealerAlertLogMutation = createAsyncThunk(
    `${route}/resendDealerAlertLogMutation`,
    async (payload, { rejectWithValue }) => {
        const { dealerId, logId } = payload;
        try {
            const response = await clientMutation(
                `mutation resendDealerAlertLog($dealerId: Int!, $logId: Int!) {
                    result: resendDealerAlertLog(dealerId: $dealerId, logId: $logId)
                }`,
                { dealerId, logId },
                endpoints.GRAPHQL_GENERAL
            );
            return { success: response?.result };
        } catch (exc) {
            return rejectWithValue(exc);
        }
    }
);

export const resendDealerAlertLogRedux = createSlice({
    name: 'dealers/resendDealerAlertLog',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
        },
        openModalResendDealerAlertLog(state, action) {
            state.openModal = true;
            state.log = action.payload.log;
            state.dealerId = action.payload.dealerId;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(resendDealerAlertLogMutation.pending, (state) => {
                state.loading = true;
            })
            .addCase(resendDealerAlertLogMutation.fulfilled, (state, action) => {
                state.result = action.payload;
                state.loading = false;
            })
            .addCase(resendDealerAlertLogMutation.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    }
});

const { actions, reducer } = resendDealerAlertLogRedux;

export const {
    reset,
    openModalResendDealerAlertLog
} = actions;

export default reducer;
